var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "data-coloringtype": "fill",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F55",
  fillRule: "evenodd",
  d: "M14.59 3.042c1.61-.766 3.551-.678 4.886 0 2.68 1.362 4.033 5.399 2.142 9.232-1.562 3.166-4.053 5.394-5.631 6.619-1.573 1.22-3.97 2.597-3.987 2.607-.03-.018-2.42-1.391-3.987-2.607-1.578-1.225-4.07-3.453-5.632-6.62-1.89-3.832-.536-7.87 2.144-9.23 1.334-.679 3.274-.767 4.885 0 1.572.746 2.57 2.378 2.59 2.411.021-.034 1.018-1.665 2.59-2.412",
  clipRule: "evenodd"
})));
export default SvgHeartFilled;